import * as v from 'valibot';
import { coercedDate, Profile, Schedule, ScheduleId, Student, StudentId, StudentName, } from '../resources/index.js';
import { api } from './_base.js';
export const teacherContracts = api({
    // Profile routes
    'GET /api/profile': {
        input: v.object({}),
        output: Profile,
        requiresSession: true,
    },
    'PUT /api/profile': {
        input: Profile,
        output: Profile,
        requiresSession: true,
    },
    // Student CRUD routes
    'GET /api/students': {
        input: v.object({
            archived: v.optional(v.picklist(['true', 'false'])),
        }),
        output: v.array(Student),
        requiresSession: true,
    },
    'GET /api/students/:id': {
        params: { id: StudentId },
        input: v.object({}),
        output: Student,
        requiresSession: true,
    },
    'PUT /api/students/:id': {
        params: { id: StudentId },
        input: Student,
        output: Student,
        requiresSession: true,
    },
    'DELETE /api/students/:id': {
        params: { id: StudentId },
        input: v.object({}),
        output: Student,
        requiresSession: true,
    },
    // Schedule CRUD routes
    'GET /api/schedules': {
        input: v.object({
            archived: v.optional(v.picklist(['true', 'false'])),
        }),
        output: v.array(Schedule),
        requiresSession: true,
    },
    'GET /api/schedules/:id': {
        params: { id: ScheduleId },
        input: v.object({}),
        output: Schedule,
        requiresSession: true,
    },
    'PUT /api/schedules/:id': {
        params: { id: ScheduleId },
        input: Schedule,
        output: Schedule,
        requiresSession: true,
    },
    'DELETE /api/schedules/:id': {
        params: { id: ScheduleId },
        input: v.object({}),
        output: Schedule,
        requiresSession: true,
    },
    // Student survey actions (special operations)
    'POST /api/students/survey-emails/bulk': {
        input: v.object({
            studentIds: v.array(StudentId),
            dueByDate: coercedDate(),
        }),
        output: v.object({
            success: v.boolean(),
            failures: v.optional(v.array(StudentName)),
        }),
        requiresSession: true,
    },
    'POST /api/students/:studentId/survey-emails': {
        params: { studentId: StudentId },
        input: v.object({
            dueByDate: coercedDate(),
        }),
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: true,
    },
    'POST /api/students/:studentId/survey-links': {
        params: { studentId: StudentId },
        input: v.object({
            dueByDate: coercedDate(),
        }),
        output: v.object({
            link: v.string(),
        }),
        requiresSession: true,
    },
});
//# sourceMappingURL=teacher.js.map